import React from 'react';
import { TrendingUpIcon, ExternalLinkIcon } from 'lucide-react';
export function TrendsSection() {
  const trendCategories = [{
    name: 'Summer 2025 Trends',
    source: 'Vogue & Cosmopolitan',
    items: [{
      id: 1,
      name: 'Crochet Everything',
      image: 'https://images.unsplash.com/photo-1619365734050-b2d521c3f671?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'up',
      description: 'From tops to dresses, crochet is having a major moment'
    }, {
      id: 2,
      name: 'Sheer Layers',
      image: 'https://images.unsplash.com/photo-1509631179647-0177331693ae?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'up',
      description: 'Transparent fabrics adding dimension to summer looks'
    }, {
      id: 3,
      name: 'Bubble Hem Skirts',
      image: 'https://images.unsplash.com/photo-1583496661160-fb5886a0aaaa?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'up',
      description: 'The Y2K revival continues with this playful silhouette'
    }, {
      id: 4,
      name: 'Coastal Grandmother',
      image: 'https://images.unsplash.com/photo-1578632292335-df3abbb0d586?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'stable',
      description: 'Breezy linen, neutral tones, and effortless elegance'
    }]
  }, {
    name: 'Fall 2025 Runway Trends',
    source: 'Net-a-Porter & Vogue',
    items: [{
      id: 5,
      name: 'Maxi Coats',
      image: 'https://images.unsplash.com/photo-1548624313-0396c75f8e60?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'up',
      description: 'Floor-sweeping coats making a dramatic statement'
    }, {
      id: 6,
      name: 'Bold Red',
      image: 'https://images.unsplash.com/photo-1572804013427-4d7ca7268217?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'up',
      description: 'Vibrant red is the standout color of the season'
    }, {
      id: 7,
      name: 'Leather Bomber Jackets',
      image: 'https://images.unsplash.com/photo-1551028719-00167b16eac5?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'up',
      description: 'The aviator-inspired silhouette is back in a big way'
    }, {
      id: 8,
      name: 'Fringe Details',
      image: 'https://images.unsplash.com/photo-1581044777550-4cfa60707c03?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'up',
      description: 'From subtle to statement, fringe is everywhere'
    }]
  }, {
    name: 'Instagram Streetwear Trends',
    source: 'Instagram & Fashion Influencers',
    items: [{
      id: 9,
      name: 'Baggy Cargo Pants',
      image: 'https://images.unsplash.com/photo-1552374196-1ab2a1c593e8?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'up',
      description: 'The ultimate blend of comfort and utilitarian style'
    }, {
      id: 10,
      name: 'Oversized Blazers',
      image: 'https://images.unsplash.com/photo-1591369822096-ffd140ec948f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'stable',
      description: 'Power shoulders and relaxed fits remain a staple'
    }, {
      id: 11,
      name: 'Platform Shoes',
      image: 'https://images.unsplash.com/photo-1543163521-1bf559a7a30e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'up',
      description: 'Adding height and drama to everyday looks'
    }, {
      id: 12,
      name: 'Micro Mini Skirts',
      image: 'https://images.unsplash.com/photo-1583846783214-7229a91b20ed?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
      trend: 'down',
      description: 'Ultra-short hems giving way to longer silhouettes'
    }]
  }];
  // Function to verify image URLs are valid and non-duplicate
  const verifyImageUrls = categories => {
    const usedUrls = new Set();
    return categories.map(category => {
      const verifiedItems = category.items.map(item => {
        // If this is a duplicate URL, generate a new one with a timestamp to make it unique
        if (usedUrls.has(item.image)) {
          const newUrl = `${item.image}?t=${Date.now()}`;
          usedUrls.add(newUrl);
          return {
            ...item,
            image: newUrl
          };
        }
        usedUrls.add(item.image);
        return item;
      });
      return {
        ...category,
        items: verifiedItems
      };
    });
  };
  const verifiedTrendCategories = verifyImageUrls(trendCategories);
  return <div id="trends" className="bg-white rounded-xl shadow-md p-6" data-id="element-160">
      <div className="flex items-center justify-between mb-6" data-id="element-161">
        <div className="flex items-center" data-id="element-162">
          <TrendingUpIcon className="h-6 w-6 text-indigo-600 mr-2" data-id="element-163" />
          <h2 className="text-xl font-semibold text-gray-800" data-id="element-164">
            Top Fashion Trends
          </h2>
        </div>
        <span className="text-xs text-gray-500" data-id="element-165">Updated weekly</span>
      </div>
      <div className="space-y-10" data-id="element-166">
        {verifiedTrendCategories.map(category => <div key={category.name} data-id="element-167">
            <div className="flex justify-between items-center mb-4" data-id="element-168">
              <h3 className="text-lg font-medium text-gray-800" data-id="element-169">
                {category.name}
              </h3>
              <span className="text-xs text-gray-500" data-id="element-170">
                Source: {category.source}
              </span>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-171">
              {category.items.map(item => <div key={item.id} className="group" data-id="element-172">
                  <div className="aspect-w-1 aspect-h-1 rounded-lg overflow-hidden bg-gray-100" data-id="element-173">
                    <img src={item.image} alt={item.name} className="object-cover w-full h-full group-hover:opacity-90 transition" onError={e => {
                // Fallback image if the original fails to load
                e.target.src = 'https://images.unsplash.com/photo-1542272604-787c3835535d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80';
              }} data-id="element-174" />
                  </div>
                  <div className="mt-2" data-id="element-175">
                    <div className="flex justify-between items-center" data-id="element-176">
                      <p className="text-sm font-medium text-gray-900" data-id="element-177">
                        {item.name}
                      </p>
                      <span className={`flex items-center text-xs font-medium ${item.trend === 'up' ? 'text-green-600' : item.trend === 'down' ? 'text-red-600' : 'text-gray-500'}`} data-id="element-178">
                        {item.trend === 'up' && '↑'}
                        {item.trend === 'down' && '↓'}
                        {item.trend === 'stable' && '→'}
                        <span className="ml-1" data-id="element-179">
                          {item.trend === 'up' && 'Trending'}
                          {item.trend === 'down' && 'Declining'}
                          {item.trend === 'stable' && 'Stable'}
                        </span>
                      </span>
                    </div>
                    <p className="text-xs text-gray-600 mt-1" data-id="element-180">
                      {item.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>)}
      </div>
    </div>;
}